import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const MEDIA = '(min-width: 48em)';

const View = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

const Item = styled.li`
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 12px;
    border: ${props =>
        props.contrast ? `1px solid ${props.contrast}` : 'none'};
    border-radius: 50%;
    display: inline-block;
    vertical-align: top;
    position: relative;
    background-color: ${props => props.color};
    background-size: cover;
    cursor: pointer;

    @media ${MEDIA} {
        margin: 0;
        margin-bottom: ${props => props.size / 2}px;
        display: block;
    }

    ${props => {
        if (props.imageSrc)
            return css`
                background-image: url(${props.imageSrc});
            `;
    }} &::after {
        content: '';
        width: 100%;
        height: 100%;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: inherit;
        opacity: 0;
        transition: transform 0.3s ease-in-out, opacity 0.2s 0.1s ease-in-out;
    }

    &:hover {
        &::after {
            transform: scale(1.5);
            opacity: 0.35;
        }
    }

    ${props => {
        if (props.active) {
            return css`
                &::after {
                    transform: scale(1.5);
                    opacity: 0.35;
                }
            `;
        }
    }};
`;

const CheckIcon = styled.svg`
    width: inherit;
    height: inherit;
    fill: ${props => (props.contrast ? props.contrast : '#fff')};
    position: relative;
    z-index: 1;
`;

const Chooser = props => {
    const SIZE = props.size === 'small' ? 15 : 25;

    return (
        <View>
            {props.items.map((item, i) => {
                return (
                    <Item
                        key={JSON.stringify(item)}
                        color={item.color}
                        contrast={item.contrast}
                        imageSrc={item.imageSrc}
                        size={SIZE}
                        onClick={e => props.onChoose(i, item, e)}
                        active={props.selectedIndex === i}
                    >
                        {props.selectedIndex === i && (
                            <CheckIcon
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                contrast={item.contrast}
                            >
                                <path
                                    d="M11.06 15.1l-4.38-4.04-1.36 1.48 6.06 5.57L18.82 7.6l-1.64-1.16"
                                    fillRule="nonzero"
                                />
                            </CheckIcon>
                        )}
                    </Item>
                );
            })}
        </View>
    );
};

Chooser.defaultProps = {
    colors: [],
    size: 'normal',
    onChoose: () => {},
};

Chooser.propTypes = {
    /** [
     *      { imageSrc: null, color: '#cccccc'},
     *      { imageSrc: 'path/to/image.png', color: 'lightblue'},
     * ] */
    items: PropTypes.arrayOf(
        PropTypes.shape({
            imageSrc: PropTypes.string,
            color: PropTypes.string,
        })
    ),

    selectedIndex: PropTypes.number,

    /** ['normal', 'small'] */
    size: PropTypes.oneOf(['normal', 'small']),

    onChoose: PropTypes.func,
};

export default Chooser;



// WEBPACK FOOTER //
// ./src/components/shared/Chooser.js